<template>
  <a-config-provider :locale="locales">
    <router-view></router-view>
  </a-config-provider>
</template>

<script>
import { messages } from "@/language/index";
import dayjs from "dayjs";
export default {
  computed: {
    locales() {
      // 语言包设置
      const locale =
        messages[this.$store.state.system.language] || messages["zh"];
      dayjs.locale(locale); // antd日期组件语言包设置
      return locale;
    },
  },
  setup() {
    return {};
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
